import React from 'react';

import styled from 'styled-components';

import { IconPlus, TextLink, Type } from '@spotify-internal/encore-creator-web';
import { gray15, gray70, white } from '@spotify-internal/encore-foundation';

import { HSpacer16 } from './index';

type AddToProfileProps = {
  dataTestId?: string;
  disabled?: boolean;
  onClick: (e: React.MouseEvent) => void;
  text: string;
  textHref?: string;
};

const OuterRect = styled.div<Pick<AddToProfileProps, 'disabled'>>`
  display: flex;
  align-items: center;
  pointer-events: ${props => (props.disabled ? 'none' : null)};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  &:hover {
    background-color: ${gray15};
  }
`;

const Text = styled(Type).attrs({ as: 'p' })`
  color: ${white};
  padding: 0;
`;

export function AddToProfile(props: AddToProfileProps) {
  let textElement = <Text>{props.text}</Text>;
  if (props.textHref) {
    textElement = (
      <TextLink href={props.textHref} style={{ textDecoration: 'none' }}>
        {textElement}
      </TextLink>
    );
  }

  return (
    <OuterRect
      data-testid={props.dataTestId}
      disabled={props.disabled}
      onClick={props.onClick}
      role="button"
    >
      <PlusBox />
      <HSpacer16 />
      {textElement}
      <HSpacer16 />
    </OuterRect>
  );
}

const OutlinedBox = styled.div`
  min-height: 96px;
  min-width: 96px;
  border: 1px solid ${gray70};
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function PlusBox() {
  return (
    <OutlinedBox>
      <IconPlus aria-hidden focusable={false} iconSize={24} />
    </OutlinedBox>
  );
}
